import { connectOrderItemProductGroup } from './connectOrderItemProductGroup';
import { OrderItemProductGroup as OrderItemProductGroupPure } from './OrderItemProductGroup';

export const OrderItemProductGroup = connectOrderItemProductGroup(OrderItemProductGroupPure);
